import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { RESIZE_SIZES } from "../../lib/constants";
import { ArrowsOut, Check } from "@phosphor-icons/react";

export default function ResizeModal({ open, onOpenChange, current, onResize }) {
  const [busy, setBusy] = useState(null);

  const handle = async (size) => {
    if (busy) return;
    setBusy(size.id);
    try { await onResize(size); } finally { setBusy(null); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#161616] border-white/10 text-white sm:max-w-lg" data-testid="resize-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-display text-lg">
            <ArrowsOut size={20} className="text-blue-400" /> Resize design
          </DialogTitle>
          <DialogDescription className="text-zinc-400 text-sm">
            Pick a new size — we'll create a resized copy and keep your original safe.
          </DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-2 gap-2.5 mt-1 max-h-[60vh] overflow-y-auto custom-scrollbar pr-1">
          {RESIZE_SIZES.map((size) => {
            const isCurrent = current && size.width === current.width && size.height === current.height;
            const ratio = size.width / size.height;
            const boxW = ratio >= 1 ? 34 : 34 * ratio;
            const boxH = ratio >= 1 ? 34 / ratio : 34;
            return (
              <button
                key={size.id}
                onClick={() => handle(size)}
                disabled={!!busy}
                data-testid={`resize-option-${size.id}`}
                className="flex items-center gap-3 p-3 rounded-xl border border-white/10 bg-white/[0.03] hover:bg-white/[0.07] hover:border-blue-500/50 transition-colors text-left disabled:opacity-50"
              >
                <div className="w-9 h-9 flex items-center justify-center shrink-0">
                  <div style={{ width: boxW, height: boxH }} className="rounded-[3px] border border-zinc-500 bg-zinc-700/60" />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-semibold truncate flex items-center gap-1.5">
                    {size.label}
                    {isCurrent && <Check size={13} className="text-emerald-400 shrink-0" />}
                  </div>
                  <div className="text-[11px] text-zinc-500">{busy === size.id ? "Creating…" : size.sub}</div>
                </div>
              </button>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
